import { TileRendererProvider, martinPerssonRenderer } from "../tiles/index.js"
import TopDownScreen from "../screens/play/TopDownScreen.jsx"
import FocusIndScreen from "../screens/play/FocusIndScreen.jsx"
import SchematicIndScreen from "../screens/play/SchematicIndScreen.jsx"
import { toPlayFrames } from "../model/toPlayFrames.js"

const SCREENS = {
  top_down: TopDownScreen,
  focus: FocusIndScreen,
  schematic: SchematicIndScreen,
}

export default function ChapterPlayer({ view, frames }) {
  const Screen = SCREENS[view]
  return (
    <TileRendererProvider renderer={martinPerssonRenderer}>
      <Screen frames={toPlayFrames(frames)} />
    </TileRendererProvider>
  )
}
